import { useService } from "./service.js";
import debounce from "../utils/debounce.js";
function createScrollService() {
  function updateProps() {
    const yLast = props.y;
    const xLast = props.x;
    if (window.pageYOffset !== props.y) {
      props.y = window.pageYOffset;
    }
    if (window.pageXOffset !== props.x) {
      props.x = window.pageXOffset;
    }
    props.changed.x = props.x !== xLast;
    props.changed.y = props.y !== yLast;
    props.last.x = xLast;
    props.last.y = yLast;
    props.delta.x = props.x - xLast;
    props.delta.y = props.y - yLast;
    props.max.x = (document.scrollingElement || document.body).scrollWidth - window.innerWidth;
    props.max.y = (document.scrollingElement || document.body).scrollHeight - window.innerHeight;
    props.progress.x = props.max.x === 0 ? 1 : props.x / props.max.x;
    props.progress.y = props.max.y === 0 ? 1 : props.y / props.max.y;
    props.direction.x = props.x > xLast ? "RIGHT" : props.x < xLast ? "LEFT" : "NONE";
    props.direction.y = props.y > yLast ? "DOWN" : props.y < yLast ? "UP" : "NONE";
    return props;
  }
  const onScrollDebounced = debounce(() => {
    trigger(updateProps());
  }, 100);
  function onScroll() {
    trigger(updateProps());
    onScrollDebounced();
  }
  const { add, remove, has, props, trigger } = useService({
    props: {
      x: window.pageXOffset,
      y: window.pageYOffset,
      changed: {
        x: false,
        y: false
      },
      last: {
        x: window.pageXOffset,
        y: window.pageYOffset
      },
      delta: {
        x: 0,
        y: 0
      },
      max: {
        x: (document.scrollingElement || document.body).scrollWidth - window.innerWidth,
        y: (document.scrollingElement || document.body).scrollHeight - window.innerHeight
      },
      progress: {
        x: 0,
        y: 0
      },
      direction: {
        x: "NONE",
        y: "NONE"
      }
    },
    init() {
      document.addEventListener("scroll", onScroll, { passive: true, capture: true });
    },
    kill() {
      document.removeEventListener("scroll", onScroll);
    }
  });
  return {
    add,
    remove,
    has,
    props: () => props
  };
}
let scroll;
function useScroll() {
  if (!scroll) {
    scroll = createScrollService();
  }
  return scroll;
}
export {
  useScroll as default
};
//# sourceMappingURL=scroll.js.map
